/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import OidcCallback from "@/components/OidcCallback";
import { vuexOidcCreateRouterMiddleware } from "vuex-oidc";
import store from "./store/store";
import Axios from "axios";
import logging from "./services/Logging";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/oidc-callback", // Needs to match redirectUri (redirect_uri if you use snake case) in you oidcSettings,
      name: "oidcCallback",
      component: OidcCallback,
      meta: { isOidcCallback: true }
    },
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          name: "dashboard",
          component: () => import("./views/Home.vue")
        },
        {
          path: "/profile",
          name: "profile",
          props: route => Object.assign({}, route.query),
          component: () => import("./views/profile.vue")
        },
        {
          path: "/usage/:id?",
          name: "usage",
          meta: {
            parent: "usage"
          },
          props: true,
          component: () => import("./views/Usage.vue")
        },
        {
          path: "/:token/meterreadingrequest",
          name: "MeterReadingRequest",
          meta: {
            parent: "meterreading"
          },
          props: true,

          component: () => import("./views/MeterReadingRequest.vue")
        },
        {
          path: "/:contractId/recurringamount/:baseOnCurrentEac?",
          name: "MeterReadingRequest",
          meta: {
            parent: "contracts"
          },
          props: true,
          component: () => import("./views/RecurringAmountAdvise.vue")
        },
        {
          path: "/meterreadingrequest/:token",
          name: "MeterReadingRequest",
          meta: {
            parent: "meterreading"
          },
          props: true,

          component: () => import("./views/MeterReadingRequest.vue")
        },
        {
          path: "/meterreading/:id?",
          name: "meterreading",
          meta: {
            parent: "meterreading"
          },
          props: true,
          component: () => import("./views/MeterReading.vue")
        },
        {
          path: "/verlenging/:token",
          name: "ProposalRequest",
          props: true,

          component: () => import("./views/ProposalRequest.vue")
        },
        {
          path: "/contracts",
          name: "contracts",
          component: () => import("./views/Contracts.vue")
        },
        {
          path: "/contracts/:contractId/rehousing",
          name: "rehousing",
          props: true,
          meta: {
            parent: "contracts"
          },
          component: () => import("./views/Rehousing.vue")
        },
        {
          path: "/invoices",
          name: "invoices",
          component: () => import("./views/Invoices.vue")
        },
        {
          path: "/FAQ/:id?",
          name: "FAQ",
          props: true,
          component: () => import("./views/FAQ.vue")
        },
        {
          path: "/Prices/:Id?",
          name: "Prices",
          props: true,
          component: () => import("./views/Prices.vue")
        },
        {
          path: "/error",
          name: "error",
          meta: {
            isErrorPage: true
          },
          component: () => import("./views/Error.vue")
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================

        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue")
        }
      ]
    },
    {
      path: "/oidc-silent-callback",
      component: () => import("@/views/OidcSilentCallback.vue"),
      meta: { isOidcCallback: true }
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});
router.beforeEach(vuexOidcCreateRouterMiddleware(store));
router.beforeEach((to, from, next) => {
  if (!to.meta.isErrorPage && !from.meta.isErrorPage) {
    store.commit("setErrorMessage", null);
  }

  next();
});

router.beforeEach(async (to, from, next) => {
  if (!to.meta.isErrorPage && !to.meta.isOidcCallback) {
    try {
      await Axios({
        method: "GET",
        baseURL: process.env.VUE_APP_API_BASE_URL,
        url: "/api/Health",
        timeout: 5000
      });
      next();
    } catch (err) {
      logging.logException(err);
      store.commit("setErrorMessage", {
        message:
          "Op dit moment is Mijn Naked Energy niet te bereiken, probeer het later nog eens",
        fullPath: "/"
      });

      next("/error");
    }
  } else {
    next();
  }
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
